import { useCallback } from "react";
import { Stack, useLocalSearchParams, useRouter } from "expo-router";
import { useUnistyles } from "react-native-unistyles";
import { SiteSelector } from "@src/features/alarms/components/SiteSelector";

export default function AlarmSettingsSiteSelectorPage() {
  const { theme } = useUnistyles();
  const router = useRouter();
  const { tenantId } = useLocalSearchParams<{ tenantId: string }>();

  const handleSitePress = useCallback(
    (siteId: string) => {
      router.push(`/tenants/${tenantId}/alarm-settings/${siteId}` as never);
    },
    [router, tenantId],
  );

  return (
    <>
      <Stack.Screen
        options={{
          title: "Controls",
          headerStyle: { backgroundColor: theme.colors.background },
          headerTintColor: theme.colors.text,
        }}
      />
      <SiteSelector onSitePress={handleSitePress} />
    </>
  );
}
